// extracted by mini-css-extract-plugin
export default {"NavButton":"NavButton_NavButton__xrgtX","NavButtonSecondary":"NavButton_NavButtonSecondary__XZiru"};